import React from 'react'
import styled from 'styled-components'

import { LoadingIcon } from 'src/ui/molecules/dashboard-table-icons'

const LoadingWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export const LoadingProgress = ({ size }) => {
  return (
    <LoadingWrapper>
      <LoadingIcon size={size} />
    </LoadingWrapper>
  )
}
